import React, { useState } from 'react';
import {
  Box,
  Flex,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useToast,
  Alert,
  AlertIcon
} from '@chakra-ui/react';
import UserManagement from '../../components/admin/UserManagement';
import ProjectAccess from '../../components/admin/ProjectAccess';
import { useAuth } from '../../contexts/AuthContext';

// 他のコンポーネントが実装されたら、ここでインポートする
// import ColumnManager from '../../components/admin/ColumnManager';
// import ReferenceData from '../../components/admin/ReferenceData';
// import PromptManager from '../../components/admin/PromptManager';

/**
 * 管理者ダッシュボードページ
 */
const AdminDashboard = () => {
  const { currentUser } = useAuth();
  const [tabIndex, setTabIndex] = useState(0);
  const toast = useToast();
  
  // 特権管理者かどうかを判定
  const isPrivileged = currentUser?.role === 'privileged';

  // タブの変更をハンドル
  const handleTabChange = (index) => {
    setTabIndex(index);
  };

  return (
    <Box p={4}>
      <Heading mb={6}>管理者ダッシュボード</Heading>
      <Text mb={4}>各種管理機能にアクセスできます。管理したい機能を選択してください。</Text>

      <Tabs
        variant="enclosed"
        colorScheme="blue"
        index={tabIndex}
        onChange={handleTabChange}
        isLazy
      >
        <TabList>
          <Tab>ユーザー管理</Tab>
          {isPrivileged && <Tab>Projectアクセス管理</Tab>}
          {isPrivileged && <Tab>出力カラム管理</Tab>}
          {isPrivileged && <Tab>参照データ管理</Tab>}
          {isPrivileged && <Tab>プロンプト管理</Tab>}
        </TabList>

        <TabPanels>
          {/* ユーザー管理 */}
          <TabPanel>
            <Box p={4} borderWidth="1px" borderRadius="lg">
              <UserManagement />
            </Box>
          </TabPanel>

          {/* Projectアクセス管理 */}
          {isPrivileged ? (
            <TabPanel>
              <Box p={4} borderWidth="1px" borderRadius="lg">
                <ProjectAccess />
              </Box>
            </TabPanel>
          ) : (
            <TabPanel>
              <Alert status="warning">
                <AlertIcon />
                権限がありません。この機能は特権管理者のみ利用可能です。
              </Alert>
            </TabPanel>
          )}

          {/* 出力カラム管理 - 実装したら有効化 */}
          {isPrivileged ? (
            <TabPanel>
              <Box p={4} borderWidth="1px" borderRadius="lg">
                <Text>出力カラム管理機能は現在実装中です。</Text>
                {/* <ColumnManager /> */}
              </Box>
            </TabPanel>
          ) : (
            <TabPanel>
              <Alert status="warning">
                <AlertIcon />
                権限がありません。この機能は特権管理者のみ利用可能です。
              </Alert>
            </TabPanel>
          )}

          {/* 参照データ管理 - 実装したら有効化 */}
          {isPrivileged ? (
            <TabPanel>
              <Box p={4} borderWidth="1px" borderRadius="lg">
                <Text>参照データ管理機能は現在実装中です。</Text>
                {/* <ReferenceData /> */}
              </Box>
            </TabPanel>
          ) : (
            <TabPanel>
              <Alert status="warning">
                <AlertIcon />
                権限がありません。この機能は特権管理者のみ利用可能です。
              </Alert>
            </TabPanel>
          )}

          {/* プロンプト管理 - 実装したら有効化 */}
          {isPrivileged ? (
            <TabPanel>
              <Box p={4} borderWidth="1px" borderRadius="lg">
                <Text>プロンプト管理機能は現在実装中です。</Text>
                {/* <PromptManager /> */}
              </Box>
            </TabPanel>
          ) : (
            <TabPanel>
              <Alert status="warning">
                <AlertIcon />
                権限がありません。この機能は特権管理者のみ利用可能です。
              </Alert>
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default AdminDashboard;